import {GeneralOperatorType} from "../general-operator";
import {LogicGroupType} from "./logic-group-type";
import {SelectSubjectType} from "../select-subject";

export class LogicCondition {
  public type: LogicGroupType = LogicGroupType.OR;
  public conditionType: GeneralOperatorType;
  public name: string;
  public determinantId: string;
  public items: any[] = [];
  public determinantType: string;
  public subject: SelectSubjectType;
  public status: boolean = true;
  public loading: boolean = false;
  public isDuplicate: boolean = false;
  public duplicateNames: string[] = [];
}
